import { render, staticRenderFns } from "./market-break-down.vue?vue&type=template&id=8cba264a&scoped=true"
import script from "./market-break-down.vue?vue&type=script&lang=ts"
export * from "./market-break-down.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cba264a",
  null
  
)

export default component.exports